import { useSnackbar } from "notistack";
import { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { getResponseMessage } from "../../../../../utils";
import { deleteGPTChat } from "../../../../../crud/users.crud";

export const useDeleteChat = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loadingDelete, setLoading] = useState(false);
  const [successDelete, setSuccess] = useState(false);

  const fetchDelete = useCallback(async (telegram_id?: string) => {
    setLoading(true);
    deleteGPTChat(telegram_id)
      .then(() => {
        setSuccess(true);
        enqueueSnackbar(intl.formatMessage({ id: 'CHAT.SUCCESS.DELETE' }), {
          variant: "success",
        });
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: "ERROR" })}: ${getResponseMessage(e)}`, {
          variant: "error",
        });
      })
      .finally(() => {
        setTimeout(() => {
          setSuccess(false);
        }, 200);
        setLoading(false);
      });
  }, []);
  return { fetchDelete, loadingDelete, successDelete };
};
